import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "border-b-2 border-gray-100 pb-4" };
const _hoisted_2 = { class: "w-ful" };
const _hoisted_3 = ["title"];
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("em", { class: "fa fa-chevron-left mr-1 text-sm cursor-pointer" }, null, -1);
const _hoisted_5 = [
    _hoisted_4
];
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("div", { class: "mr-1" }, [
    /*#__PURE__*/ _createElementVNode("em", { class: "fas fa-folder" })
], -1);
const _hoisted_7 = { class: "flex-grow whitespace-nowrap overflow-hidden truncate font-noto" };
const _hoisted_8 = { class: "flex w-full justify-start mt-2" };
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("i", { class: "far fa-lg fa-eye" }, null, -1);
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-lg fa-pen" }, null, -1);
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-lg fa-trash" }, null, -1);
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-lg fa-network-wired" }, null, -1);
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-lg fa-trash-restore" }, null, -1);
export function render(_ctx, _cache) {
    const _component_Button = _resolveComponent("Button");
    const _component_details_sidebar = _resolveComponent("details-sidebar");
    const _directive_copy_to_clipboard = _resolveDirective("copy-to-clipboard");
    return (_openBlock(), _createBlock(_component_details_sidebar, null, {
        header: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", {
                        title: _ctx.folderDetails.name,
                        class: "flex flex-row text-md text-primary font-bold items-center min-w-0"
                    }, [
                        _createElementVNode("div", {
                            onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('collapse-sidebar'))),
                            class: "-ml-3.5 mr-2"
                        }, _hoisted_5),
                        _hoisted_6,
                        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createTextVNode(_toDisplayString(_ctx.folderDetails.name), 1)
                        ])), [
                            [_directive_copy_to_clipboard]
                        ])
                    ], 8, _hoisted_3)
                ]),
                _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_Button, {
                        class: "hover:text-blue-800 text-blue-500",
                        shadowless: "",
                        onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (_ctx.$emit('open-folder', _ctx.folderDetails)), ["exact"])),
                        title: `${_ctx.$t('misc.actions.open')}`
                    }, {
                        default: _withCtx(() => [
                            _hoisted_9
                        ]),
                        _: 1
                    }, 8, ["title"]),
                    (_ctx.hasAccessToOperation({ accessType: _ctx.AccessType.folders, operation: _ctx.AccessOperations.rename }))
                        ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                            key: 0,
                            class: "hover:text-blue-800 text-blue-500",
                            shadowless: "",
                            onClick: _cache[2] || (_cache[2] = _withModifiers(($event) => (_ctx.$emit('edit-folder-name')), ["exact"])),
                            title: `${_ctx.$t('misc.actions.rename')}`
                        }, {
                            default: _withCtx(() => [
                                _hoisted_10
                            ]),
                            _: 1
                        }, 8, ["title"])), [
                            [_vShow, !_ctx.folderDetails.isArchived]
                        ])
                        : _createCommentVNode("", true),
                    (_ctx.hasAccessToOperation({ accessType: _ctx.AccessType.folders, operation: _ctx.AccessOperations.delete }))
                        ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                            key: 1,
                            class: "hover:text-blue-800 text-blue-500",
                            shadowless: "",
                            onClick: _cache[3] || (_cache[3] = _withModifiers(($event) => (_ctx.$emit('delete-item')), ["exact"])),
                            title: `${_ctx.$t('misc.actions.delete')}`
                        }, {
                            default: _withCtx(() => [
                                _hoisted_11
                            ]),
                            _: 1
                        }, 8, ["title"])), [
                            [_vShow, !_ctx.folderDetails.isArchived]
                        ])
                        : _createCommentVNode("", true),
                    (_ctx.isVaultAdmin && _ctx.config.enableWebdav)
                        ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                            key: 2,
                            class: "hover:text-blue-800 text-blue-500",
                            shadowless: "",
                            onClick: _cache[4] || (_cache[4] = _withModifiers(($event) => (_ctx.$emit('mount-item')), ["exact"])),
                            title: `${_ctx.$t('webdav.mount')}`
                        }, {
                            default: _withCtx(() => [
                                _hoisted_12
                            ]),
                            _: 1
                        }, 8, ["title"])), [
                            [_vShow, !_ctx.folderDetails.isArchived]
                        ])
                        : _createCommentVNode("", true),
                    (_ctx.isVaultAdmin)
                        ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                            key: 3,
                            class: "hover:text-blue-800 text-blue-500",
                            shadowless: "",
                            onClick: _cache[5] || (_cache[5] = _withModifiers(($event) => (_ctx.recoverFolders()), ["exact"])),
                            title: `${_ctx.$t('misc.actions.recover')}`
                        }, {
                            default: _withCtx(() => [
                                _hoisted_13
                            ]),
                            _: 1
                        }, 8, ["title"])), [
                            [_vShow, _ctx.folderDetails.isArchived]
                        ])
                        : _createCommentVNode("", true)
                ])
            ])
        ]),
        _: 1
    }));
}
